import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button } from "reactstrap";
import styles from "./ChatNotificationPermissionBanner.module.scss";

const DISMISS_KEY = "mxhh-chat-notification-permission-dismissed";

/**
 * Visible prompt so Firefox/Chrome actually grant notification permission.
 * Without this, desktop chat toasts stay silent.
 *
 * @param {{ permission: NotificationPermission|"", onRequest: () => Promise<unknown> }} props
 */
const ChatNotificationPermissionBanner = ({ permission, onRequest }) => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === "1"
  );

  if (typeof Notification === "undefined") {
    return null;
  }
  if (permission === "granted" || !permission) {
    return null;
  }
  if (permission === "denied" && dismissed) {
    return null;
  }

  const isDenied = permission === "denied";

  const handleEnable = async () => {
    await onRequest();
  };

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <Alert
      color={isDenied ? "danger" : "warning"}
      className={styles.banner}
    >
      <span>
        {isDenied
          ? t("messenger.chatNotificationsBlocked")
          : t("messenger.enableChatNotifications")}
      </span>
      <span className={styles.actions}>
        {!isDenied && (
          <Button color="primary" size="sm" onClick={handleEnable}>
            {t("messenger.enableChatNotificationsAction")}
          </Button>
        )}
        {isDenied && (
          <Button color="link" size="sm" onClick={handleDismiss}>
            {t("close")}
          </Button>
        )}
      </span>
    </Alert>
  );
};

export default ChatNotificationPermissionBanner;
